'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _recompose = require('recompose');

var _referrerService = require('./referrerService');

var _urlConstants = require('../../../../common/utils/urlConstants');

var ReferralRedirect = (0, _recompose.createSink)(function (_ref) {
    var routeParams = _ref.routeParams;
    var referrer = routeParams.referrer;

    if (referrer) (0, _referrerService.setReferrer)(referrer);

    window.location = _urlConstants.REFERRAL_REDIRECT_URL + '?r=' + referrer;
});

exports.default = ReferralRedirect;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/referral/ReferralRedirect.js
// module id = 2080
// module chunks = 0